import { useMemo } from 'react'

import { useCurrentPractice } from 'contexts/PracticeContext'
import { Banner, BannerVariant } from 'components/common/banner'
import Contact from 'icons/Contact'

import { CompleteInquiryButton } from './CompleteInquiryButton'
import { shouldShow1099InfoBanner } from '../helpers'
import { PERSONA_PROCESS_TYPES } from '../../../../constants'
import { BANNER_1099_INFO_PARAMS } from '../../../../config'

export const Practice1099InfoRequiredBanner: React.FC = () => {
	const processType = PERSONA_PROCESS_TYPES['1099_INFO']
	const { currentPracticeObject, setCurrentPracticeObject } = useCurrentPractice()

	const show1099InfoBanner = useMemo(
		() => shouldShow1099InfoBanner(currentPracticeObject),
		[currentPracticeObject]
	)

	const handleCompletedProcess = () => {
		// TODO: improve this. Maybe refetching the context?
		setCurrentPracticeObject({
			...currentPracticeObject,
			consolidatedPractice: {
				...currentPracticeObject?.consolidatedPractice,
				status: {
					...currentPracticeObject?.consolidatedPractice?.status,
					[processType]: {
						...currentPracticeObject?.consolidatedPractice?.status?.[processType],
						status: 'completed'
					}
				}
			}
		})
	}

	if (!show1099InfoBanner) {
		return null
	}

	if (!BANNER_1099_INFO_PARAMS.dueDate || !BANNER_1099_INFO_PARAMS.url) {
		return null
	}

	return (
		<Banner
			customIcon={<Contact fontSize="medium" sx={{ mr: 1 }} />}
			customActionButtons={
				<CompleteInquiryButton
					processType={PERSONA_PROCESS_TYPES['1099_INFO']}
					onCompleted={handleCompletedProcess}
				/>
			}
			tooltip="Action Required: Update Your Tax Info for IRS Compliance"
			title="Action Required: Update Your Tax Info for IRS Compliance"
			subtitle={`To ensure timely filing of your IRS Form 1099-K, submit your latest W9 information by ${BANNER_1099_INFO_PARAMS.dueDate}.`}
			buttonTitle="Update"
			variant={BannerVariant.ERROR}
			linkTarget="_blank"
			href={BANNER_1099_INFO_PARAMS.url}
			showCloseButton
			showButton
		/>
	)
}
